/**
 * @file  seller/index.ts
 * @description  seller service
 *
 * @author dlima (dlima-electron)
 *
 */

/**
 * Imports.
 */
import * as _cache from '../cache';
import Seller from './model';

const sellerKey = _cache.Key.seller;

export const showSeller = process.env.REACT_APP_SELLER_NAME === 'true';

/**
 * gets the current seller
 * @returns the seller
 */
export const getSeller = async (): Promise<Seller> => {
  const seller: Seller = _cache.getItem<Seller>(sellerKey);
  return seller;
};

/**
 * removes the seller from the cache
 */
export const clearSeller = async (): Promise<void> => {
  _cache.removeItem(sellerKey);
};

/**
 * sets a seller
 * @param sellerName seller name
 * @param sellerCode seller code
 * @returns the seller element
 */
export const setSeller = async (
  sellerName: string,
  sellerCode: string
): Promise<Seller> => {
  const seller: Seller = {
    sellerName,
    sellerCode
  };

  // do not reset seller when we load the home page again
  if (sellerCode?.trim() === '') {
    return seller;
  }

  _cache.setItem<Seller>(sellerKey, seller);
  window.dispatchEvent(new Event('set-seller-cache'));

  return seller;
};

/**
 * sets a seller from utm_content tag
 * @returns the seller element
 */
export const setSellerFromUtmContent = async (): Promise<void> => {
  const code = new URLSearchParams(window.location.search).get('utm_content') || '';
  if (code) {
    setSeller('', code);
  }
};
